import { render, staticRenderFns } from "./TemplateBuilderHeader.vue?vue&type=template&id=61f67f24&scoped=true&"
import script from "./TemplateBuilderHeader.vue?vue&type=script&lang=js&"
export * from "./TemplateBuilderHeader.vue?vue&type=script&lang=js&"
import style0 from "./TemplateBuilderHeader.vue?vue&type=style&index=0&id=61f67f24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f67f24",
  null
  
)

export default component.exports